import { Result } from '../../../functions/src/types/firestore/Game/Tournament/Round/Match/Result';
import { CentralizerContextFactory } from '../edit/CentralizerContextFactory';

export const ResultCentralizerContext =
  CentralizerContextFactory.buildFirestoreDocument<Result>();
